const includedSideCartRouteNames = [
    'storefront',
    'storefront-collection',
    'store-slug-about',
]

export default {
    computed: {
        __canSeeSideCart() {
            if (
                this.$helpers.isLoggedIn &&
                includedSideCartRouteNames.includes(this.$page.currentRouteName)
            ) {
                return true
            }
            return false
        },
    },
}
